import { useAuthStore } from './auth.store';

export function useAuth() {
  const session = useAuthStore((s) => s.session);
  const user = useAuthStore((s) => s.user);
  const loading = useAuthStore((s) => s.loading);
  return {
    session,
    user,
    loading,
    isAuthenticated: !!session,
  };
}
